<template>
  <span class="block">
    <el-select
      v-model="dataValue"
      filterable
      clearable
      @change="selecDate"
      class="selectWord"
    >
      <el-option label="按月份导出数据" value=""></el-option>
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>
    </el-select>
    <!-- <el-date-picker
      class="date-picker"
      v-model="value"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      @change="dataSearch"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      v-if="hackReset"
      align="right"
    ></el-date-picker> -->
  </span>
</template>

<script>
export default {
  data() {
    return {
      radio: 0,
      options: [
      ],
      value: [],
      dataValue: "",
      hackReset: true,
      month: '',
      year: ''
    };
  },
  created() {
    this.setOPtions()
	//this.getMonthBetween(24)
  },
  methods: {
	getMonthBetween(len) {
	let dataArr = [];
	let data = new Date();
	data.setMonth(data.getMonth() + 1, 1)			//获取到当前月份,设置月份
	for (let i = 0; i < len; i++) {
	data.setMonth(data.getMonth() - 1);		//每次循环一次 月份值减1
	let m = data.getMonth() + 1;
	m = m < 10 ? "0" + m : m;
	let day=data.getFullYear() + "年" + m + "月"
	dataArr.push({ value:day, label:day});
	}
	console.log(dataArr)
	return dataArr
	},
    //设置日期选项
    setOPtions() {
      this.options=this.getMonthBetween(24)
    },
    //快速定位日期
    selecDate(item) {
		let date = new Date(); //获取当前日期对象
		let to_year = date.getFullYear(); //获取当前年份
      this.dataValue = item.value;
      let year = this.dataValue?.split('年')[0]
      var start, end, searchMonth, monthDay;
	console.log(item.value)
      if(item.value) {
        searchMonth = item.value.slice(5,7)
      }else{
	return	this.$emit('MonthSearch', [] )
	}
      if(searchMonth == '01' || searchMonth == '03' || searchMonth == '05' || searchMonth == '07' || searchMonth == '08' || searchMonth == '10' || searchMonth == '12') {
        monthDay = '31'
      }else if( searchMonth == '04' || searchMonth == '06' || searchMonth == '09' || searchMonth == '11') {
        monthDay = '30'
      }else if(searchMonth == '02') {
        let isRunYear = this.mxIsRunYear(to_year)
        if(isRunYear) {
          monthDay = '29'
        }else {
          monthDay = '28'
        }
      }
      start = year + '-' + searchMonth + '-' + '01' + ' '+  '00:00:00'
      end = year + '-' + searchMonth + '-' + monthDay + ' ' + '23:59:59'
      if(start && end) {
        this.$set(this.value, "0", start)
        this.$set(this.value, "1", end)
        this.$emit('MonthSearch', this.value )
      
      }
      this.$nextTick(() => {
        this.hackReset = true
        this.$emit('pick', [start, end]);
      });
    },
  },
};
</script>
<style scoped lang="stylus">
.selectWord
  width: 155px
.date-picker {
  margin-left: 10px;
  width: 250px;
}
.block {
  margin-right: 20px;
}
</style>